(ns nosco.images)

(defn thumbnail-url
  "Returns the thumbnail URL for an image URL."
  [image-url]
  (when image-url
    (str image-url "?size=thumbnail")))
